export default {
  row1: [
    {
      column: "column1",

      rows: {
        row1: [
          {
            name: "branchSNo",
            label: "Brach SNo",
            component: "text-field",
            Required: true,
            dataType: "int",
            width : "20%"
          },
          {
            name: "companyType",
            label: "Company Type",
            component: "dropdown",
            width : "20%",
            options: [
              {
                label: "Private",
                value: "Private",
              },
              {
                label: "Goverment Department",
                value: "GovermentDepartment",
              },
              {
                label: "Goverment Undertakings",
                value: "GovermentUndertakings",
              },
              {
                label: "Diplomatic/UN-its org",
                value: "Diplomatic/UN-itsorg",
              },
              {
                label: "Public Sector",
                value: "PublicSector",
              },
              {
                label: "Ship Stores",
                value: "ShipStores",
              },
              {
                label: "Vessel & Ships",
                value: "VesselShips",
              },
              {
                label: "AirCraft",
                value: "AirCraft",
              },
              {
                label: "Hand Carriage",
                value: "HandCarriage",
              },
              {
                label: "UnClaimed Cargo",
                value: "UnClaimedCargo",
              },
            ],
          },
          {
            name: "exporterHouse",
            label: "Exporter House",
            component: "dropdown",
            options: [
              {
                label: "N/A",
                value: "N/A",
              },
              {
                label: "ExportHouse",
                value: "ExportHouse",
              },
              {
                label: "Star Trading House",
                value: "Star Trading House",
              },
              {
                label: "Super Star Trading House",
                value: "Super Star Trading House",
              },
              {
                label: "Trading House",
                value: "Trading House",
              },
            ],
            width : "20%"
          },
          {
            name: "paymentMethod",
            label: "Payment Method",
            component: "dropdown",
            options: [
              {
                label: "Transaction",
                value: "Transaction",
              },
              {
                label: "Deferred",
                value: "Deferred",
              },
            ],
            width : "20%"
          },
          {
            name: "exporterType",
            label: "Exporter Type",
            component: "dropdown",
            options: [
              {
                label: "Manufacturer Exporter",
                value: "Manufacturer Exporter",
              },
              {
                label: "Merchant Exporter",
                value: "Merchant Exporter",
              },
              {
                label: "Other",
                value: "Other",
              },
            ],
            width : "20%"
          },
        ],
      },
    },
  ],
};
